module.exports = "/_next/static/images/front-852408a7f5b874a8d2bab4b241023dc2.jpg";